import { render } from "./CustomLeafNodeInLazyMode.vue?vue&type=template&id=d6ff8ede"
import script from "./CustomLeafNodeInLazyMode.vue?vue&type=script&lang=js"
export * from "./CustomLeafNodeInLazyMode.vue?vue&type=script&lang=js"
script.render = render

export default script